// extracted by mini-css-extract-plugin
export var growableInput = "_7k-0";
export var tagContainer = "_7k-2";
export var textInput = "_7k-1";